module.exports = __webpack_public_path__ + "assets/img/number_times_item2.4d26bd1a.png";